import React, { useState } from 'react';

function Star({ fill = 'empty', size = 36, color = '#facc15' }) {
  const id = `half-${Math.random().toString(36).slice(2)}`;
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      {fill === 'half' && (
        <defs>
          <clipPath id={id}>
            <rect x="0" y="0" width="12" height="24" />
          </clipPath>
        </defs>
      )}
      <path
        d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
        fill={fill === 'full' ? color : '#1f1f2e'}
        stroke={fill === 'empty' ? '#374151' : 'none'}
        strokeWidth="1.5"
      />
      {fill === 'half' && (
        <path
          d="M12 2l3.09 6.26L22 9.27l-5 4.87 1.18 6.88L12 17.77l-6.18 3.25L7 14.14 2 9.27l6.91-1.01L12 2z"
          fill={color}
          clipPath={`url(#${id})`}
        />
      )}
    </svg>
  );
}

// Interactive star rating — click once = full, click same star again = half
export function StarRatingInput({ value, onChange, size = 36, color = '#facc15' }) {
  const [hovered, setHovered] = useState(null);
  const displayed = hovered !== null ? hovered : value;

  const handleClick = (star) => {
    onChange(value === star ? star - 0.5 : star);
  };

  return (
    <div className="flex items-center gap-1">
      {[1, 2, 3, 4, 5].map((star) => {
        const fill = displayed >= star ? 'full' : displayed >= star - 0.5 ? 'half' : 'empty';
        return (
          <button
            key={star}
            type="button"
            onMouseEnter={() => setHovered(star)}
            onMouseLeave={() => setHovered(null)}
            onClick={() => handleClick(star)}
            className="transition-transform duration-150 hover:scale-110 active:scale-95 focus:outline-none"
            style={{ filter: fill === 'full' ? `drop-shadow(0 0 6px ${color}80)` : 'none' }}
            aria-label={`Rate ${star}`}
          >
            <Star fill={fill} size={size} color={color} />
          </button>
        );
      })}
      <span className="ml-2 font-bold text-lg" style={{ color }}>
        {value}
        <span className="text-gray-600 font-normal text-sm">/5</span>
      </span>
    </div>
  );
}

// Read-only star display — supports half stars and color prop
export function StarDisplay({ value, size = 18, color }) {
  const num = parseFloat(value) || 0;
  const starColor = color || '#facc15';
  return (
    <div className="flex items-center gap-0.5">
      {[1, 2, 3, 4, 5].map((star) => {
        const fill = num >= star ? 'full' : num >= star - 0.5 ? 'half' : 'empty';
        return <Star key={star} fill={fill} size={size} color={starColor} />;
      })}
    </div>
  );
}

export default StarRatingInput;
